/*eslint no-unused-expressions: ["warn", { "allowShortCircuit": true, "allowTernary": true }]*/
import { useEffect } from 'react';

/**
 * Adds the page level google analytics script
*/
const GAPageTracker = ({ allowTracking }) => {
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return undefined;
  }
  useEffect(() => {
    try {
      if (window.dataLayer) {
          return;
      }

      window.dataLayer = window.dataLayer || [];
      const userInfoCookie = getCookie('userinfo') ? JSON.parse(getCookie('userinfo')) : undefined;
      window.dataLayer.push({
        "event": "page_data",
        "user": {
          "logged_in": userInfoCookie !== undefined,
          "user_id":  userInfoCookie ? userInfoCookie.user_id : undefined,
          "experience_level": userInfoCookie ? userInfoCookie.experience : undefined,
          "ei": userInfoCookie ? userInfoCookie.ei : undefined,
          "enterprise": userInfoCookie ? userInfoCookie.enterprise : undefined
        }
      });

      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://stream.edgeimpulse.com/gtm.js?id='+i+dl;f.parentNode.insertBefore (j,f);
      })(window,document,'script','dataLayer','GTM-PLFFMH6');

    } catch (e) {
      console.log("Exception pushing to GA: ", e);
    }
  });


  // useEffect(() => {
  //   if (!allowTracking) return;

  //   if (window.location.host.indexOf('localhost') === 0) {
  //     window.ga = function (a, b) {
  //       // console.log('ga event', a, b);
  //     };
  //   } else {
  //     (function (i, s, o, g, r, a, m) {
  //       i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
  //         (i[r].q = i[r].q || []).push(arguments)
  //       }, i[r].l = 1 * new Date(); a = s.createElement(o),
  //         m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  //     })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  //   }

  //   window.ga('create', 'UA-147980949-1');
  //   window.ga('send', 'pageview');
  // }, [allowTracking]);

  return null;
};

export default GAPageTracker;